export function isJsonString(string: string) {
  try {
    JSON.parse(string);
  } catch (e) {
    console.debug({ jsonException: e });
    return false;
  }
  return true;
}
